import React, { Suspense, useState } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { connect } from 'react-redux';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { bindActionCreators } from 'redux';
import { login, closeManagerCheck } from '@reducers/oauth';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import style from './checksCommon.module.scss';
import cn from 'classnames';
import {
  removeSeat,
  updateSeatInfo
} from '@reducers/orders';
import {
  updateChecksAfterResponse
} from '@reducers/storeChecks';
import isEmpty  from 'lodash/isEmpty';
  import EventEmitter from '@utility/eventSubscribers';
import Ringtone from '@assets/tones/beep-08b.mp3';
import { playRingtone } from '@utility/helperFunction';
import ModalHeader from '../common/ModalHeader/index';
const  Modal = React.lazy(() =>  import('@components/common/Modal'));
const LoginKeyboard = React.lazy(() => import('@components/common/formElements/SimpleKeyboard/loginKeyboard'));
const FullWithModal = React.lazy(() => import('@components/common/Modal/FullWidthModal'));

const ManagerCheck = (props) => {
  const {
    isManagerCheck,
    setIsVoidOpen,
    flowType,
    setOthersPopUp,
    setIsSetupOffPremise,
    tileHead,
    orderingPortraitOrientation
  } = props;

  const [isSwipe, setIsSwipe] = useState(false);

  const onSubmit = (data, empCard) => {
    setIsSwipe(false);
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      manager: true,
      deviceId: props.deviceInfo.deviceId,
      employeeCode: data.managerCode,
      employeeCard: empCard || null
    };
    props.login(dataToSend,true).then(() => {
      setIsVoidOpen(true);
    }).catch((err) => {
      props.setErrorPopUp({
        res: err.message
      })
    });
  };

  const validateLogin = (data) => {
    return new Promise((resolve, reject) => {
      const error = {};
      if (!data.managerCode) {
        error.managerCode = '';
        props.setErrorPopUp({ res: CUSTOM_MESSAGES().MANAGER_CODE_IS_REQUIRED, noErrorTxt: true });
      }
      if (isEmpty(error)) {
        resolve();
      } else {
        reject(new Error(error.managerCode));
      }
    });
  };
  const handleStopMagneticRead = () => {
    EventEmitter.stopMagneticCardRead();
    EventEmitter.sendMessage({ type: 'stopMagCard' }, () => {
      console.log('success');
    },
    () => {
      console.log('failure');
    });
    setIsSwipe(false);
  };

  const initializeIngenico = () => {
    try {
      EventEmitter.scanIngenicoDevice((res) => {
        onSubmit({}, res);
      },
      () => {
        handleStopMagneticRead();
      });
      EventEmitter.sendMessage({ type: 'scanMagCard' }, () => {
        console.log('success');
      },
      () => {
        console.log('failure');
      });
    } catch (e) {
      console.log('catch', e);
    }
  };

  const cardReader = () => {
    playRingtone(Ringtone);
    setIsSwipe(true);
    initializeIngenico();
  };

  const handleClose = () => {
    setIsSetupOffPremise(true);
    props?.closeManagerCheck();
    // props.setVoidCheckOpen(false);
    setIsVoidOpen(false);
  }

  return (
    <>
      {props.loading && <Loader />}
      <Suspense fallback={<Loader />}>
      {isManagerCheck &&
        <FullWithModal
        isOpen={isManagerCheck}
        isModalCenter
        style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundColor: props.serverAppTheme?.popUp_bg, backgroundClip: 'padding-box', height: '100%' }}
        customClass='h-100 w-100'
        customClass2='h-100 w-100'
        noBackground
      >
        <div className="d-flex flex-column   align-items-center text-center position-relative h-100" style={{ color: props.serverAppTheme?.primary_text}}>
          <ModalHeader
            isTab={props.seat?.tab}
            stationName={props.seat?.stationName}
            tileHeader={tileHead}
            seatNumber={props.seat?.number}
          />
          <div className={cn('py-2 w-100 d-flex flex-column justify-content-center align-items-center', orderingPortraitOrientation ? 'h-100 position-absolute' : '')} style={{top: orderingPortraitOrientation ? '20%' : ''}}>
            <div className={cn('mt-2', orderingPortraitOrientation ? 'h-5 fs_24 fw-400' : 'h-10 fw-500 fs_20 ')}>{CUSTOM_MESSAGES().ENTER_MANAGER_CODE}</div>
            <Suspense fallback={<Loader />}>
            <LoginKeyboard
              containerClass={cn('mt-3', orderingPortraitOrientation ? 'w-100 h-100 px-3' : 'w-60 h-78 px-2')}
              customClass='py-2'
              type="number"
              name="managerCode"
              validate={validateLogin}
              buttonName={['kiosk'].includes(flowType) ? LABEL().KIOSK_SUBMIT : props?.deviceInfo?.deviceGroup?.serverAppSettings?.disableLoginWithKeypad ? LABEL().CLICK_TO_SWIPE_CARD : LABEL().SUBMIT}
              placeholder={LABEL().ENTER_OTP}
              onSubmit={onSubmit}
              goToSwiper={cardReader}
              auth={props.auth}
              serverAppTheme={props.serverAppTheme}
              closeBtn={LABEL().CANCEL}
              handleClose={handleClose}
              orderingPortraitOrientation={orderingPortraitOrientation}
              />
              </Suspense>
          </div>
        </div>
          </FullWithModal>}
      </Suspense>
      <Suspense fallback={<Loader />}>
      {isSwipe && <Modal isOpen={isSwipe}
        isModalCenter
        style={{ backgroundColor: props.serverAppTheme?.popUp_bg, borderRadius: '16px', border: props.serverAppTheme?.popupBorder, boxShadow: props.serverAppTheme?.popUp_box_shadow }}
        noBackground>
        <div className="row mb-0" style={{ color: props.serverAppTheme?.primary_text }}>
          <div className="col-12 fs-14  mt-20 mb-20 justify-content-center align-items-center text-center">
            Please swipe the card after the beep
          </div>
          <div className="col-12 fs-14 mt-20 mb-20 justify-content-center align-items-center text-center">
            <button className={cn("btn", style.secondary_btn)} style={{ backgroundColor: props.serverAppTheme?.secondaryBtn, color: props.serverAppTheme?.btn_font_color }} type="button" onClick={() => { setIsSwipe(false); handleStopMagneticRead(); }}>
              {LABEL().CANCEL}
            </button>
          </div>
        </div>
        </Modal>}
        </Suspense>
    </>
  );
};

const mapStateToProps = ({ oauth, theme, orders}) => ({
  loading: oauth.loading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  isManagerCheck: oauth.isManagerCheck,
  serverAppTheme: theme.serverAppTheme,
  tileHead: oauth.tileHead,
  seat: orders.seats,
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  login,
  setNotification,
  closeManagerCheck,
  removeSeat,
  updateSeatInfo,
  updateChecksAfterResponse,
  setErrorPopUp
}, dispatch);

const MemoisedManagerCheck = React.memo(ManagerCheck);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoisedManagerCheck);